var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-icon',{attrs:{"large":"","color":_vm.color}},[_vm._v("mdi-checkbox-blank-circle")])}
var staticRenderFns = []

export { render, staticRenderFns }